<script lang="ts">
	import '../app.css';
	import { onMount } from 'svelte';
	import { theme } from '$lib/stores/theme';
	import { browser } from '$app/environment';

	let { children } = $props();

	onMount(() => {
		// Synchronise l'attribut data-theme dès le montage (au cas où le script inline aurait été contourné)
		if (browser) {
			document.documentElement.setAttribute('data-theme', $theme);
		}
	});
</script>

{@render children()}
